import { render, staticRenderFns } from "./PageBienvenido.vue?vue&type=template&id=71da49d4&"
import script from "./PageBienvenido.vue?vue&type=script&lang=js&"
export * from "./PageBienvenido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports